export const getAutomaton = (state, automatonType) => state[automatonType];


// WEBPACK FOOTER //
// ./src/selectors/automaton.js